export const BG_URLS = [
  "https://s0.vingle.net/images/signup_landing_image/01_1.jpg",
  "https://s0.vingle.net/images/signup_landing_image/01_2.jpg",
  "https://s0.vingle.net/images/signup_landing_image/02_1.jpg",
  "https://s0.vingle.net/images/signup_landing_image/02_2.jpg",
  "https://s0.vingle.net/images/signup_landing_image/03_1.jpg",
  "https://s0.vingle.net/images/signup_landing_image/03_2.jpg",
  "https://s0.vingle.net/images/signup_landing_image/04_1.jpg",
  "https://s0.vingle.net/images/signup_landing_image/04_2.jpg",
];

export const BG_URLS_LENGTH = BG_URLS.length;

export const COMMENTS_LENGTH = 4;
